<template>
  <div class="tiktok">
    <div ref="embedContainer" />
    <load-script
      v-if="loadScriptSrc"
      :src="loadScriptSrc"
    />
  </div>
</template>

<script>
  import { intersectionViewportObserver } from '@Foundation/utilities/intersectionViewportObserver';
  import LoadScript from '@Foundation/loadscript/loadscript';

  export default {
    name: 'Tiktok',

    components: {
      LoadScript,
    },

    props: {
      videoUrl: {
        required: true,
        type: String,
      },
    },

    data: () => ({
      loadScriptSrc: null,
    }),

    mounted() {
      intersectionViewportObserver(this.$el, { checkIsVisible: false }).then(() => {
        this.getEmbed();
      });
    },

    methods: {
      getEmbed() {
        const endpoint = `https://www.tiktok.com/oembed?url=${this.videoUrl}`;

        fetch(endpoint)
          .then((response) => response.json())
          .then(this.renderIframe)
          .then(this.loadSafeScript)
          .catch((error) => {
            console.error('Could not embed', error); // eslint-disable-line no-console
          });
      },
      loadSafeScript() {
        const randomId = (Math.random() * 100 * Date.now()).toFixed();
        this.loadScriptSrc = `//www.tiktok.com/embed.js?q=${randomId}`;
      },
      removeUnsafeScript(xml) {
        return xml.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
      },
      renderIframe({ html }) {
        const cleanEmbedHtml = this.removeUnsafeScript(html);
        this.$refs.embedContainer.innerHTML = cleanEmbedHtml;
      },
    },
  };
</script>
